export type HomeArticleLike = {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  sourceUrl?: string | null;
  publishedAt?: Date | string | null;
};

export type HomeMatchLike = {
  homeTeam: string;
  awayTeam: string;
  broadcastChannel?: string | null;
  commentator?: string | null;
};

export type HomeArticleCard = {
  article: HomeArticleLike;
  match: HomeMatchLike | null;
};

export function getVisibleArticles<T>(articles: T[], visibleCount: number): T[] {
  return articles.slice(0, Math.max(0, visibleCount));
}

/**
 * Builds the complete homepage article feed. Match-linked articles are placed
 * first so today's coverage remains prominent, while unrelated articles are
 * retained instead of being hidden in the /news archive.
 */
export function getHomeMatchArticleCards(
  articles: HomeArticleLike[],
  matches: HomeMatchLike[],
): HomeArticleCard[] {
  const cards = articles.map((article) => {
    const text = `${article.title} ${article.excerpt} ${article.content}`;
    const match = matches.find(
      (item) => text.includes(item.homeTeam) && text.includes(item.awayTeam),
    ) ?? null;
    return { article, match };
  });

  return cards.sort((a, b) => Number(Boolean(b.match)) - Number(Boolean(a.match)));
}
